import bmAxiosClient from "../../GenAPI/axiosClient";

const login = (data) => bmAxiosClient.post('/api/users/login', data);

export default {login};